import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=09794fca&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09794fca')) {
      api.createRecord('09794fca', component.options)
    } else {
      api.reload('09794fca', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=09794fca&", function () {
      api.rerender('09794fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s17uMpxCTk5Z/JS/offershelp.vue"
export default component.exports